<template>
  <el-form
      ref="form"
      :model="form">
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor">
        <el-tabs :value="'first'">
          <el-tab-pane
              label="排除品牌"
              name="first"
              >
            <div class="gj-picker__editor--search-input">
              <gj-input
                  v-model="keyword"
                  placeholder="搜索品牌"
                  size="medium"
                  underline
                  width="100%">
                <template #append>
                  <gj-button
                      icon="el-icon-search"
                      size="medium"
                      @click="searchBrand"></gj-button>
                </template>
              </gj-input>
            </div>
            <div class="gj-picker__editor--body" style="border-top: 1px solid #e8eaec;">
              <gj-table
                  :index="false"
                  :show-pagination="false"
                  :adapt-height="false"
                  :height="368"
                  :loading="loading"
                  :data="brandData"
                  :columns="columns0"
                  stripe>
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="addAllItem()"
                  >添加全部</gj-button>
                </template>
                <template v-slot:header:brand>
                  {{ brandHeaderName }}
                </template>
                <template v-slot:brand="{ row }">
                  {{ row.name | defaultShow}}
                </template>
                <template v-slot:op="{ index, row }">
                  <gj-button
                      type="text"
                      :disabled="row.isAddPage || row.isAdd"
                      @click="addItem(index, row)"
                  >添加</gj-button>
                </template>
              </gj-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="排除ASIN" name="second">
            <div style="margin: 10px 12px 0;">
              <div style="margin-bottom: 10px;">
                <gj-textarea
                    v-model="inputText"
                    :styles="{
                      height: '343px',
                      'border-color': this.errorKeyword ? '#F56C6C' : '',
                      fontSize: '12px'
                    }"
                    resize="none"
                    placeholder="请输入ASIN，一行一个，回车换行">
                </gj-textarea>
              </div>
              <el-row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  class="gj-picker__editor--footer">
                <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
                <!---->
                <gj-button
                    type="primary"
                    @click="addByInput"
                    :disabled="!isMeaningful(inputText)"
                >添加</gj-button>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="403"
            stripe
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:negativedProduct="{ row }">
            <template v-if="isMeaningful(row.asin)">ASIN： {{row.asin}}</template>
            <template v-else-if="isMeaningful(row.name)">品牌： {{row.name}}</template>
            <template v-else>-</template>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
import {formMixin, isMeaningfulMixin} from "@/minxins";
import {isMeaningful, isMeaningless, meaningfulEq, unique} from "@/utils/common";
import { getSuggestedBrand } from "@/api/ad";

export default {
  name: "app-neg-target-picker",
  mixins: [isMeaningfulMixin, formMixin],
  props: {
    title: {
      required: true,
    },
    marketId: {
      required: true,
      default: null
    },
    params: {
      default: ()=>({})
    }
  },
  created() {},
  data() {
    return {
      marketBrandData: [],
      brandData: [], // 排除品牌数据
      brandHeaderName: '您的品牌',
      loading: false,
      keyword: "",
      inputText: null,
      columns0: [
        {id: 'brand', header: 'slot:brand', field: 'slot:brand', minWidth: '180px'},
        {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px'},
      ],
      columns: [
        {id: 'negativedProduct', header: '否定目标', field: 'slot:negativedProduct', minWidth: '180px'},
        {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px'},
      ],
      errorKeyword: false,
      keywordStyle: {height: '292px'},
      brandLoading: false
    }
  },
  methods: {
    // 获取排除品牌
    async getProductBrand(param = {}) { // 外面ref有引用
      this.loading = true
      let params = {
        marketId: this.marketId,
        keyword: this.keyword ? this.keyword : param.keyword,
        campaignId: param.campaignId || null
      }
      this.params.campaignId && (params.campaignId = this.params.campaignId)
      try {
        let res = await getSuggestedBrand(params)
        this.brandData = res.data || []
        this.refreshBtnDisable();
      } finally {
        this.loading = false
      }
    },
    searchBrand() {
      if (isMeaningless(this.keyword)) {
        this.$gjMessage.warning('请输入品牌名后搜索');
        return;
      }
      this.getProductBrand()
    },
    // 添加全部
    addAllItem() {
      this.form.items = unique([].concat(this.form.items).concat(this.brandData));
      this.refreshBtnDisable();
    },
    // 添加
    addItem(index, row) {
      this.form.items = unique([].concat(this.form.items).concat([row]));
      this.refreshBtnDisable();
    },
    refreshBtnDisable() {
      this.brandData.forEach(e1 => {
        if (this.form.items.some(e2 => meaningfulEq(e1.id, e2.id))) {
          this.$set(e1, 'isAddPage', true);
        } else {
          this.$set(e1, 'isAddPage', false);
        }
      });
    },
    deleteAllItem() {
      this.form.items = [];
      this.refreshBtnDisable();
    },
    deleteItem(index) {
      this.form.items.splice(index, 1);
      this.refreshBtnDisable();
    },
    addByInput() {
      const items = [];
      this.inputText.split('\n')
        .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
        .filter(item => isMeaningful(item) && !/\n+/.test(item))
        .forEach(item => {
          items.push({
            id: item,
            asin: item
          });
        });
      this.form.items = unique([].concat(this.form.items).concat(items));
      this.inputText = null;
    },
    formValidate() {
      let formValid = this.form.items.length > 0;
      if (!formValid) {
        this.$gjMessage.error('请添加否定商品');
        return false;
      }
      this.$refs.form.validate((valid) => {
        formValid = formValid && valid;
      });
      return formValid;
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "picker";
  .gj-picker__editor {
    &::before {
      content: "否定商品投放";
      left: -85px;
    }
  }
  .gj-picker__editor {
    padding: 0;
  }

  .gj-picker {
    height: 445px;
  }
  
  .gj-picker__editor,
  .gj-picker__table {
    width: 500px;
    height: 443px !important;
  }
  
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }
  
  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: 13px;
    border-width: 0;
    padding: 0 12px;
    // border-bottom-width: 1px;
    font-size: 12px;
    &::placeholder {
      font-size: 12px;
    }
  }

  /deep/ .gj-picker__editor--search-input .el-input-group__append {
    border-radius: 0;
    border-right: 0;
    font-size: 14px;
  }
  /deep/ .el-input-group__append{
    border: none;
  }
  /deep/ .vxe-table--border-line{
    border: none;
  }
  /deep/.el-tabs__content {
    padding: 0 !important;
  }
  /deep/.gj-underline-input {
    margin-top: 1px;
  }
</style>

